export default __webpack_public_path__ + "static/media/rps.0aaadf3d.svg";